export const supportedResolutions = ['1', '5', '15', '30', '60', '240', 'D', 'W', 'M'];
